export default {
  LOGIN_LOADING: 'LOGIN_LOADING',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  LOGIN_REJECT: 'LOGIN_REJECT',

  GET_ME_INFO_LOADING: 'GET_ME_INFO_LOADING',
  GET_ME_INFO_FAILED: 'GET_ME_INFO_FAILED',
  GET_ME_INFO_REJECT: 'GET_ME_INFO_REJECT',
  GET_ME_INFO_SUCCESS: 'GET_ME_INFO_SUCCESS',


  FORGET_PASSWORD_LOADING: 'FORGET_PASSWORD_LOADING',
  FORGET_PASSWORD_FAILED: 'FORGET_PASSWORD_FAILED',
  FORGET_PASSWORD_REJECT: 'FORGET_PASSWORD_REJECT',
  FORGET_PASSWORD_SUCCESS: 'FORGET_PASSWORD_SUCCESS',

  CHECK_VERIFICATION_CODE_LOADING: 'CHECK_VERIFICATION_CODE_LOADING',
  CHECK_VERIFICATION_CODE_FAILED: 'CHECK_VERIFICATION_CODE_FAILED',
  CHECK_VERIFICATION_CODE_REJECT: 'CHECK_VERIFICATION_CODE_REJECT',
  CHECK_VERIFICATION_CODE_SUCCESS: 'CHECK_VERIFICATION_CODE_SUCCESS',

  SET_NEW_PASSWORD_LOADING: 'SET_NEW_PASSWORD_LOADING',
  SET_NEW_PASSWORD_FAILED: 'SET_NEW_PASSWORD_FAILED',
  SET_NEW_PASSWORD_REJECT: 'SET_NEW_PASSWORD_REJECT',
  SET_NEW_PASSWORD_SUCCESS: 'SET_NEW_PASSWORD_SUCCESS',
};
